import DateUtils from '@shared/utils/date';
import Focus from '@shared/types/enums/focus';
import Rail from '../../../shared/classes/rail';
import TMain from '../templates/main';
import useEpgByDays from '@shared/components/utils/hooks/useEpgByDays';
import { routerSelector } from '../../../shared/store/slices/router.slice';
import { setFocus } from '@shared/store/slices/focus.slice';
import { useAppDispatch, useAppSelector } from '../../../shared/store/hooks';
import { useEffect, useState } from 'react';
import {
  RailDisplayMode,
  RailOrderSort,
  RailOrderType,
} from '@shared/types/enums/rail';

export default function ChannelGuide() {
  const dispatch = useAppDispatch();
  const {
    params: { current: currentParams },
  } = useAppSelector(routerSelector);
  const [rails, setRails] = useState<Rail[]>(
    (currentParams?.rails as Rail[]) || []
  );
  const { complete, epg, onPagination } = useEpgByDays({
    channelId: (currentParams?.channelId as string) || '',
  });

  useEffect(() => {
    if (currentParams?.previousFocus) {
      dispatch(setFocus(currentParams.previousFocus as Focus));
    } else if (complete) {
      dispatch(
        setFocus([Focus.RAILS_LIST, parseInt(`${Focus.RAILS_SUB_LIST}${0}`)])
      );
    }
  }, [complete]);

  useEffect(() => {
    const newRails: Rail[] = [];
    for (const [key, events] of Object.entries(epg)) {
      const rail = Rail.constructorWithData(
        {
          staticRail: true,
          section: {
            title: DateUtils.getTime({
              customDate: key,
              displayDay: true,
              displayHours: false,
              displayMinutes: false,
              displaySeconds: false,
              displayDayOfWeek: true,
              displayToday: false,
              separator: ' ',
            }),
            presentationType: RailDisplayMode.PHOTO,
            name: 'ChannelGuide',
          },
        },
        events
      );
      rail.sortRail(RailOrderType.DATE, RailOrderSort.ASCENDING);
      newRails.push(rail);
    }
    setRails(newRails);
  }, [epg]);

  return (
    <TMain
      rails={rails}
      sliders={[]}
      complete={complete}
      forceDescription={true}
      startsInMenu={false}
      onPagination={onPagination}
    />
  );
}
